import { render, staticRenderFns } from "./v-sidebar-language.vue?vue&type=template&id=df328148&scoped=true&"
import script from "./v-sidebar-language.vue?vue&type=script&lang=js&"
export * from "./v-sidebar-language.vue?vue&type=script&lang=js&"
import style0 from "./v-sidebar-language.vue?vue&type=style&index=0&id=df328148&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df328148",
  null
  
)

export default component.exports